import { render, staticRenderFns } from "./BadgetTest.vue?vue&type=template&id=594fa3a7&scoped=true"
import script from "./BadgetTest.vue?vue&type=script&lang=ts"
export * from "./BadgetTest.vue?vue&type=script&lang=ts"
import style0 from "./BadgetTest.vue?vue&type=style&index=0&id=594fa3a7&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "594fa3a7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/r1/a/_stemdoplatform/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('594fa3a7')) {
      api.createRecord('594fa3a7', component.options)
    } else {
      api.reload('594fa3a7', component.options)
    }
    module.hot.accept("./BadgetTest.vue?vue&type=template&id=594fa3a7&scoped=true", function () {
      api.rerender('594fa3a7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/app/components/main-drawer/main-drawer-item/BadgetTest.vue"
export default component.exports